import { render, staticRenderFns } from "./RidgeModal.vue?vue&type=template&id=381e85f4&scoped=true&"
import script from "./RidgeModal.vue?vue&type=script&lang=js&"
export * from "./RidgeModal.vue?vue&type=script&lang=js&"
import style0 from "./RidgeModal.vue?vue&type=style&index=0&id=381e85f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381e85f4",
  null
  
)

export default component.exports